import React, { Component } from "react";
import { graphql, compose } from "react-apollo";
import {
  queryGetResponseRateLeaderboard,
  queryGetAverageResponseRate,
  queryGetResponseRate,
  queryGetResponseRateWithinSLALeaderboard,
  queryGetAverageResponseRateWithinSLA,
  queryGetResponseRateWithinSLA,
} from "Apollo";
import { GetAnalyticFilter } from "Store";
import { observer } from "mobx-react";
import {
  InlineWidgetWrapper,
  WidgetMember,
  WidgetMember2
} from "./components/Widget";
import Chart from "./components/Chart";
import InlineOrderedBox from "./components/InlineOrderedBox";
import ManagedTable from "./components/ManagedTable";
import Moment from 'moment'

const gqlOptions = {
  options: {
    fetchPolicy: "network-only"
  }
};
const Box = compose(
  graphql(queryGetResponseRateWithinSLALeaderboard, {
    ...gqlOptions,
    name: "leaderboard"
  }),
  graphql(queryGetAverageResponseRateWithinSLA, { ...gqlOptions, name: "average" }),
  graphql(queryGetResponseRateWithinSLA, { ...gqlOptions, name: "basic" })
)(
  class ResponseRatePanel extends Component {
    getChart() {
      const {
        leaderboard: { loading, getResponseRateWithinSLALeaderboard }
      } = this.props;
      let series = [];
      if (!loading && getResponseRateWithinSLALeaderboard) {
        const blockSeries = getResponseRateWithinSLALeaderboard.data.reduce(
          (memo, dataPoint) => {
            let timestamp = dataPoint.name;
            dataPoint.details.forEach(agent => {
              let name = agent.name;
              let value = agent.value;
              if (!memo[name]) {
                memo[name] = [];
              }
              memo[name].push({
                name: timestamp,
                value: parseFloat(value.toFixed(2))
              });
            });
            return memo;
          },
          {}
        );
        for (let agentName in blockSeries) {
          series.push({
            name: agentName,
            data: blockSeries[agentName].sort((a, b) => {
              let tA = Moment(a.name).toDate().getTime()
              let tB = Moment(b.name).toDate().getTime()
              if(tA < tB) return -1
              else return 1
            })
          });
        }
      }
      let opt = {
        chartType: "line",
        title: "Response Rate within SLA",
        series
      };
      return <Chart {...opt} />;
    }

    getSummary() {
      const { leaderboard, average } = this.props;
      let highestBox = {
        title: "Highest",
        mainContent: "",
        footer: {
          text: ""
        }
      };
      let lowestBox = {
        title: "Lowest",
        mainContent: "",
        footer: {
          text: ""
        }
      };
      let averageBox = {
        title: "Average",
        mainContent: "",
        footer: {
          text: ""
        }
      };
      if (!leaderboard.loading && leaderboard.getResponseRateWithinSLALeaderboard) {
        const normalizedAgentValue = leaderboard.getResponseRateWithinSLALeaderboard.data
          .reduce((memo, item) => {
            return memo.concat(item.details);
          }, [])
          .sort((a, b) => {
            if(a.value < b.value) {
              return -1
            } else return 1
          }).filter(item => item.value > 0)
        if (normalizedAgentValue.length >= 2) {
          const lowest = normalizedAgentValue[0];
          const highest = normalizedAgentValue[normalizedAgentValue.length - 1];
          highestBox.mainContent = highest.value.toFixed(1) + " %";
          highestBox.footer.text = "by "+highest.name;
          lowestBox.mainContent = lowest.value.toFixed(1) + " %";
          lowestBox.footer.text = "by "+lowest.name;
        } else if (normalizedAgentValue.length === 1) {
          const elem = normalizedAgentValue[0];
          highestBox.mainContent = elem.value.toFixed(1) + " %";
          highestBox.footer.text = "by "+elem.name;
          lowestBox.mainContent = elem.value.toFixed(1) + " %";
          lowestBox.footer.text = "by "+elem.name;
        }
      }
      if (!average.loading && average.getAverageResponseRateWithinSLA) {
        if (average.getAverageResponseRateWithinSLA.data[0]) {
          const elem = average.getAverageResponseRateWithinSLA.data[0];
          averageBox.mainContent = elem.value.toFixed(1) + " %";
        }
      }
      const opt = {
        contentList: [lowestBox, highestBox, averageBox],
        size: "small"
      };
      return <InlineOrderedBox {...opt} />;
    }

    getTable() {
      const { basic: { loading, getResponseRateWithinSLA } } = this.props;
      let series = [
        {
          date: "",
          rate: "",
          responded: "",
          incoming: ""
        }
      ];
      if (!loading && getResponseRateWithinSLA) {
        if (getResponseRateWithinSLA.data.length > 0) {
          series = getResponseRateWithinSLA.data.map(item => {
            let realRate = "-"
            if(item.value > 0) {
              realRate = item.value.toFixed(2) + " %"
            }
            const responded = item.details.find(
              detailItem => detailItem.name === "responded_count_within_SLA"
            );
            const incoming = item.details.find(
              detailItem => detailItem.name === "incoming_count"
            );
            return {
              date: Moment(item.name).format("YYYY-MM-DD"),
              rate: realRate,
              responded: responded ? responded.value : 0,
              incoming: incoming ? incoming.value : 0
            };
          });
        }
      }
      const opt = {
        title: "Daily Response Rate",
        contentList: series
      };
      return <ManagedTable {...opt} />;
    }

    render() {
      const table = this.getTable();
      const chart = this.getChart();
      const summary = this.getSummary();
      return (
        <InlineWidgetWrapper>
          <WidgetMember>{chart}</WidgetMember>
          <WidgetMember2>
            {summary}
            {table}
          </WidgetMember2>
        </InlineWidgetWrapper>
      );
    }
  }
);

export default observer(
  class BoxWithQuery extends Component {
    render() {
      return <Box {...GetAnalyticFilter()} />;
    }
  }
);



// WEBPACK FOOTER //
// ./src/module-analytics/ResponseRatePanel.js